// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_account_connect_view from "./web_account_connect_view.js";
import * as Mapre_web__Web_account_sharing_model from "./web_account_sharing_model.js";
import * as Mapre_web__Web_account_sharing_view from "./web_account_sharing_view.js";
import * as Mapre_web__Web_accounts_model from "./web_accounts_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function disabled(form) {
  if (form.loading || form.pending) {
    return true;
  } else {
    return Stdlib__Option.fold(false, Mapre_web__Web_account_sharing_model.busy, form.sharing);
  }
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.account_form, Mapre_web__Web_accounts_model.initial(""));
  }), model);
  const partial_arg = "Personal subscriptions";
  const partial_arg$1 = 2;
  const partial_arg$2 = "These accounts belong to you across workspaces. Use a Devin personal access token or sign in with Cursor or Grok. ChatGPT enrollment is not available yet.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = "Loading accounts...";
  const partial_arg$5 = "muted";
  const partial_arg$6 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$7 = Signal.map((function (p) {
    return p.loading;
  }), source);
  const partial_arg$8 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg$9 = Signal.map((function (p) {
    return p.items;
  }), source);
  const partial_arg$10 = Signal.map((function (p) {
    return p.cursor !== undefined;
  }), source);
  const partial_arg$11 = {
    TAG: /* Accounts */ 41,
    _0: /* Close */ 0
  };
  const partial_arg$12 = (function (param) {
    return Lui_elements.press(send, partial_arg$11, param);
  });
  const partial_arg$13 = "ghost";
  const partial_arg$14 = "Close accounts";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___009_) {
      const partial_arg = {
        TAG: /* Accounts */ 41,
        _0: /* Refresh */ 1
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map(disabled, source)));
      const partial_arg$3 = "outline";
      const partial_arg$4 = "Refresh accounts";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$15 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$16 = "wrap";
  const partial_arg$17 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: Mapre_web__Web_account_connect_view.view(source, send),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$8, (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___007_) {
                const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (p) {
                  return p.message;
                }), source)));
                const partial_arg$1 = "notice";
                return function (param, param$1) {
                  return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }), param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.keyed(partial_arg$9, (function (a) {
                return a.id;
              }), Stdlib__String.compare, (function (param) {
                const item = Signal.sample(param);
                const partial_arg = Signal.map((function (x) {
                  return Stdlib__List.mem(x.provider, {
                    hd: "devin",
                    tl: {
                      hd: "cursor",
                      tl: {
                        hd: "grok",
                        tl: /* [] */ 0
                      }
                    }
                  });
                }), param);
                const partial_arg_0 = function (param$1, param$2) {
                  return Lui_elements.if_(partial_arg, (function (param$3, param$4) {
                    return Lui_elements.scoped((function (__lui_context___004_) {
                      const partial_arg = {
                        TAG: /* Accounts */ 41,
                        _0: {
                          TAG: /* Reconnect */ 4,
                          _0: item.id
                        }
                      };
                      const partial_arg$1 = (function (param) {
                        return Lui_elements.press(send, partial_arg, param);
                      });
                      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
                        return Stdlib__Option.fold(true, disabled, m.account_form);
                      }), model)));
                      const partial_arg$3 = "outline";
                      const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (x) {
                        return "Reconnect " + x.label;
                      }), param)));
                      return function (param, param$1) {
                        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param$3, param$4);
                  }), param$1, param$2);
                };
                const partial_arg_1 = {
                  hd: (function (param$1, param$2) {
                    return Lui_elements.scoped((function (__lui_context___005_) {
                      const partial_arg = {
                        TAG: /* Accounts */ 41,
                        _0: {
                          TAG: /* Sharing */ 15,
                          _0: {
                            TAG: /* Open */ 0,
                            _0: item.id
                          }
                        }
                      };
                      const partial_arg$1 = (function (param) {
                        return Lui_elements.press(send, partial_arg, param);
                      });
                      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
                        return Stdlib__Option.fold(true, (function (p) {
                          if (disabled(p)) {
                            return true;
                          } else {
                            return p.selected !== undefined;
                          }
                        }), m.account_form);
                      }), model)));
                      const partial_arg$3 = "outline";
                      const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (x) {
                        return "Manage sharing " + x.label;
                      }), param)));
                      return function (param, param$1) {
                        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param$1, param$2);
                  }),
                  tl: {
                    hd: (function (param$1, param$2) {
                      return Lui_elements.scoped((function (__lui_context___006_) {
                        const partial_arg = {
                          TAG: /* Accounts */ 41,
                          _0: {
                            TAG: /* Disconnect */ 5,
                            _0: item.id
                          }
                        };
                        const partial_arg$1 = (function (param) {
                          return Lui_elements.press(send, partial_arg, param);
                        });
                        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (m) {
                          return Stdlib__Option.fold(true, disabled, m.account_form);
                        }), model)));
                        const partial_arg$3 = "ghost";
                        const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (x) {
                          return "Disconnect " + x.label;
                        }), param)));
                        return function (param, param$1) {
                          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                        };
                      }), param$1, param$2);
                    }),
                    tl: /* [] */ 0
                  }
                };
                const partial_arg$1 = {
                  hd: partial_arg_0,
                  tl: partial_arg_1
                };
                const partial_arg$2 = "wrap";
                const partial_arg$3 = 8;
                const partial_arg$4 = function (param, param$1) {
                  return Lui_elements.row(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, param, param$1);
                };
                const partial_arg$5 = Signal.map((function (x) {
                  return x.status !== "revoked";
                }), param);
                const partial_arg_0$1 = function (param$1, param$2) {
                  return Lui_elements.scoped((function (__lui_context___001_) {
                    const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (x) {
                      return x.label;
                    }), param)));
                    return function (param, param$1) {
                      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param$1, param$2);
                };
                const partial_arg_1$1 = {
                  hd: (function (param$1, param$2) {
                    return Lui_elements.scoped((function (__lui_context___002_) {
                      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (x) {
                        return Stdlib__Option.value(x.name, "Not verified");
                      }), param)));
                      return function (param, param$1) {
                        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param$1, param$2);
                  }),
                  tl: {
                    hd: (function (param$1, param$2) {
                      return Lui_elements.scoped((function (__lui_context___003_) {
                        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (x) {
                          return x.status;
                        }), param)));
                        const partial_arg$1 = "muted";
                        return function (param, param$1) {
                          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                        };
                      }), param$1, param$2);
                    }),
                    tl: {
                      hd: (function (param, param$1) {
                        return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
                      }),
                      tl: /* [] */ 0
                    }
                  }
                };
                const partial_arg$6 = {
                  hd: partial_arg_0$1,
                  tl: partial_arg_1$1
                };
                const partial_arg$7 = {
                  hd: [
                    "data-personal-account",
                    item.id
                  ],
                  tl: /* [] */ 0
                };
                const partial_arg$8 = "command-card";
                const partial_arg$9 = 12;
                const partial_arg$10 = 6;
                return function (param, param$1) {
                  return Lui_elements.column(undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
                };
              }), param, param$1);
            }),
            tl: {
              hd: Mapre_web__Web_account_sharing_view.view(model, send),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.if_(partial_arg$10, (function (param, param$1) {
                    return Lui_elements.scoped((function (__lui_context___008_) {
                      const partial_arg = {
                        TAG: /* Accounts */ 41,
                        _0: /* More */ 2
                      };
                      const partial_arg$1 = (function (param) {
                        return Lui_elements.press(send, partial_arg, param);
                      });
                      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map(disabled, source)));
                      const partial_arg$3 = "outline";
                      const partial_arg$4 = "More accounts";
                      return function (param, param$1) {
                        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param, param$1);
                  }), param, param$1);
                }),
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.row(undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, undefined, partial_arg$15, param, param$1);
                  }),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$18 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$19 = "form-card";
  const partial_arg$20 = 0;
  const partial_arg$21 = 16;
  const partial_arg$22 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$22, undefined, undefined, undefined, undefined, undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$20, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$19, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$18, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
